import type { SidePanelState } from "./side-panel.type";

import { atom } from "jotai";

export const sidePanelAtom = atom<SidePanelState>({ visible: false });
